import axios from 'axios';

const instance = axios.create({

    auth: null,
    baseURL: 'https://growappdev.geodan.nl/api/',
});

const getDeviceAuthFallback = () => {

    const auth = instance.defaults.auth || instance.defaults.deviceAuth;
    return auth ? 'Basic ' + btoa(auth.username + ':' + auth.password) : null;
};

export default instance;
export {

    getDeviceAuthFallback,
}



// WEBPACK FOOTER //
// ./src/components/services/axios.js